import { Link, Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { components } from "library/api/card-management-service.generated";

interface Props {
  phoneOtpResponse: components["schemas"]["PhoneVerifyResponse"];
}

export const Success = ({ phoneOtpResponse }: Props) => (
  <Stack gap="8">
    <SvgInline name="icon-celebrate" size="120" />
    <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
      Your phone number has been updated successfully
    </Text>
    <Stack gap="4" testId="residential-address">
      <Text as="h3" textStyle="heading5" color="primary.blue.t100">
        Mobile number
      </Text>
      <Text>{phoneOtpResponse.mobile_number}</Text>
    </Stack>
    <Text>
      Changes may take up to 24 hours to update in all Latitude systems and
      processes.
    </Text>
    <Link
      appearance="primary-button"
      width="256"
      href="/manage-personal-details"
      newTab={false}
    >
      Manage personal details
    </Link>
  </Stack>
);
